// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====================== BASIC RESET ====================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.attx-container {
  width: auto;
  height: 480px;
  border: 1px solid rgb(228, 227, 227);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.attx-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid #dcd4d4;
}

.attx-header h2 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 24px;
  font-weight: bold;
  padding-top: 10px;
}
.attx-subheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  width: 100%;
}

/* ====================== TABLE CONTAINER ====================== */
.attx-main {
  height: 400px;
  /* margin-top: -13px; */
  display: flex;
  flex-direction: row;
  position: relative;
}

.attx-table-wrap {
  flex: 1 1;
  margin: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 356px;
  background: #fff;
}

/* optional: scrollbar smoothness */
.attx-table-wrap::-webkit-scrollbar {
  width: 6px;
}
.attx-table-wrap::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

/* ====================== TABLE ====================== */
.attx-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 680px;
}

/* ✅ fixed selector + compact padding */
.attx-table th,
.attx-table td {
  padding: 3px 4px;
  text-align: center;
  border: 1px solid #ddd;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1.2;
}

.attx-table th {
  background-color: #deecdd;
  position: sticky;
  top: 0;
  font-size: 12px;
  font-weight: bold;
  z-index: 2;
}

.attx-table tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

/* S.No column narrow */
.attx-sno {
  width: 6%;
}

/* Employee details */
.attx-emp-name {
  font-weight: 600;
}

.attx-emp-id {
  font-size: 11px;
  color: gray;
  margin-top: 2px;
  margin-left: 20px;
}
.line1 {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
/* ====================== DAY CELL ====================== */
.attx-day-cell {
  display: flex;
  gap: 4px;
  
}
.totalhrs{
  padding-top: 2px;
}
.attx-day {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px; /* kam gap */
  padding: 2px 0; /* kam padding */
  min-height: 38px; /* row height kam */
}

.attx-inout {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 1px 6px; /* compact box */
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 10px; /* thoda small */
  background: #fff;
}

.attx-in {
  color: green;
  font-weight: 600;
}

.attx-out {
  color: green;
  font-weight: 600;
}
.attx-working-hours {
  font-size: 10px;
  font-weight: 600;
  color: red;
   border: 1px solid #ddd;
  border-radius: 8px;
  padding: 2px;
  background: #fff;
}
.attx-divider {
  opacity: 0.6;
}

/* location icon */
.attx-location {
  font-size: 12px;
  color: #555;
  cursor: pointer;
  transition: 0.2s;
}

.attx-location:hover {
  color: #1a8f6c;
  transform: scale(1.2);
}

/* no data */
.attx-nodata {
  color: #999;
  font-size: 12px;
}

/* ====================== POPUP ====================== */
.attx-popup {
  width: 300px;
  min-height: 380px;
  background: linear-gradient(rgb(248, 248, 248), rgb(216, 229, 214));
  border-left: 2px solid #c5d8c4;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  padding: 15px 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: attx-slideInCenter 0.9s ease;
  z-index: 1000;
}

/* popup header */
.attx-popup-header {
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1.5px solid #ccc;
  padding-bottom: 6px;
}

.attx-popup-header h3 {
  font-size: 17px;
  text-align: center;
  color: cadetblue;
  font-weight: 600;
}

.attx-popup-close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 22px;
  color: #666;
  cursor: pointer;
  transition: 0.2s;
}

.attx-popup-close:hover {
  color: red;
}

/* popup content */
.attx-popup-content ul {
  list-style: none;
  margin-top: 10px;
  padding-left: 5px;
}

.attx-popup-content li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  font-size: 13px;
  color: #444;
}

.attx-popup-content a {
  color: #1d7e68;
  font-weight: 500;
  text-decoration: none;
}

.attx-popup-content a:hover {
  text-decoration: underline;
}

/* animation — right se slide hote hue center tak */
@keyframes attx-slideInCenter {
  from {
    transform: translate(50%, -50%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
}

/* ====================== RESPONSIVE ====================== */
@media screen and (max-width: 1024px) {
  .attx-main {
    flex-direction: column;
  }

  .attx-popup {
    width: 100%;
    border-radius: 0 0 10px 10px;
    margin-top: 10px;
  }
}

@media screen and (max-width: 767px) {
  .attx-table th,
  .attx-table td {
    font-size: 8px;
    padding: 3px;
  }

  .attx-popup-content li {
    font-size: 12px;
  }
}

.attx-verify {
  font-size: 11px;
  color: #1a8f6c;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}

.attx-verify:hover {
  text-decoration: underline;
  color: #0e5f4a;
}

.attx-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(128, 128, 128, 0.5);
  z-index: 999;
}

.attx-filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 10px 20px;
}

.attx-filter label {
  margin-bottom: 1px;
  font-size: 14px;
  font-weight: 600;
  color: #444;
}

.attx-filter input {
  width: 230px;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  transition: 0.2s;
}

.attx-filter input:focus {
  border-color: #1a8f6c;
  box-shadow: 0 0 4px rgba(26, 143, 108, 0.3);
}

.attx-popup-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.attx-popup-list li {
  margin-bottom: 8px;
  font-size: 14px;
}

/* Make in/out location on one line */
.attx-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}

.attx-inline strong {
  width: 120px; /* fixed width for label alignment */
  flex-shrink: 0;
}

.attx-inline span {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}

.attx-scroll-text {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  color: #0077cc;
  font-size: 13px;
}

.attx-scroll-text:hover::after {
  content: attr(title);
  position: absolute;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  color: #333;
  font-size: 11px;
  padding: 6px 8px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  white-space: normal;
  width: 150px;
  z-index: 999;
  line-height: 1.4;
  text-align: center;
}

.attx-scroll-text:hover {
  color: #005fa3;
}

.attx-address-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-left: 5px;
}

.attx-table-wrap {
  overflow-x: auto;
}

.attx-search-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
}

.attx-date-input {
  width: 130px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
}

.attx-search-button {
  padding: 6px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
}
.attx-search-input {
  padding: 6px, 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 220px;
  margin-left: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Team/MyTeam/Attendance.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,2DAA2D;AAC3D;EACE,aAAa;EACb,QAAQ;;AAEV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ,EAAE,YAAY;EACtB,cAAc,EAAE,gBAAgB;EAChC,gBAAgB,EAAE,mBAAmB;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB,EAAE,gBAAgB;EAClC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe,EAAE,gBAAgB;EACjC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;GACT,sBAAsB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,iBAAiB;EACjB,mEAAmE;EACnE,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uCAAuC;EACvC,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE;IACE,+BAA+B;IAC/B,UAAU;EACZ;EACA;IACE,gCAAgC;IAChC,UAAU;EACZ;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY,EAAE,oCAAoC;EAClD,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["/* ====================== BASIC RESET ====================== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.attx-container {\n  width: auto;\n  height: 480px;\n  border: 1px solid rgb(228, 227, 227);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.attx-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin-bottom: 10px;\n  width: 100%;\n  border-bottom: 1px solid #dcd4d4;\n}\n\n.attx-header h2 {\n  text-align: center;\n  margin-bottom: 15px;\n  font-size: 24px;\n  font-weight: bold;\n  padding-top: 10px;\n}\n.attx-subheader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: bold;\n  width: 100%;\n}\n\n/* ====================== TABLE CONTAINER ====================== */\n.attx-main {\n  height: 400px;\n  /* margin-top: -13px; */\n  display: flex;\n  flex-direction: row;\n  position: relative;\n}\n\n.attx-table-wrap {\n  flex: 1;\n  margin: 15px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 356px;\n  background: #fff;\n}\n\n/* optional: scrollbar smoothness */\n.attx-table-wrap::-webkit-scrollbar {\n  width: 6px;\n}\n.attx-table-wrap::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 10px;\n}\n\n/* ====================== TABLE ====================== */\n.attx-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  min-width: 680px;\n}\n\n/* ✅ fixed selector + compact padding */\n.attx-table th,\n.attx-table td {\n  padding: 3px 4px;\n  text-align: center;\n  border: 1px solid #ddd;\n  font-weight: 600;\n  white-space: nowrap;\n  line-height: 1.2;\n}\n\n.attx-table th {\n  background-color: #deecdd;\n  position: sticky;\n  top: 0;\n  font-size: 12px;\n  font-weight: bold;\n  z-index: 2;\n}\n\n.attx-table tbody tr:nth-child(odd) {\n  background-color: #f9f9f9;\n}\n\n/* S.No column narrow */\n.attx-sno {\n  width: 6%;\n}\n\n/* Employee details */\n.attx-emp-name {\n  font-weight: 600;\n}\n\n.attx-emp-id {\n  font-size: 11px;\n  color: gray;\n  margin-top: 2px;\n  margin-left: 20px;\n}\n.line1 {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n/* ====================== DAY CELL ====================== */\n.attx-day-cell {\n  display: flex;\n  gap: 4px;\n  \n}\n.totalhrs{\n  padding-top: 2px;\n}\n.attx-day {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px; /* kam gap */\n  padding: 2px 0; /* kam padding */\n  min-height: 38px; /* row height kam */\n}\n\n.attx-inout {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 1px 6px; /* compact box */\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 10px; /* thoda small */\n  background: #fff;\n}\n\n.attx-in {\n  color: green;\n  font-weight: 600;\n}\n\n.attx-out {\n  color: green;\n  font-weight: 600;\n}\n.attx-working-hours {\n  font-size: 10px;\n  font-weight: 600;\n  color: red;\n   border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 2px;\n  background: #fff;\n}\n.attx-divider {\n  opacity: 0.6;\n}\n\n/* location icon */\n.attx-location {\n  font-size: 12px;\n  color: #555;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.attx-location:hover {\n  color: #1a8f6c;\n  transform: scale(1.2);\n}\n\n/* no data */\n.attx-nodata {\n  color: #999;\n  font-size: 12px;\n}\n\n/* ====================== POPUP ====================== */\n.attx-popup {\n  width: 300px;\n  min-height: 380px;\n  background: linear-gradient(rgb(248, 248, 248), rgb(216, 229, 214));\n  border-left: 2px solid #c5d8c4;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  padding: 15px 20px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: attx-slideInCenter 0.9s ease;\n  z-index: 1000;\n}\n\n/* popup header */\n.attx-popup-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-bottom: 1.5px solid #ccc;\n  padding-bottom: 6px;\n}\n\n.attx-popup-header h3 {\n  font-size: 17px;\n  text-align: center;\n  color: cadetblue;\n  font-weight: 600;\n}\n\n.attx-popup-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 22px;\n  color: #666;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.attx-popup-close:hover {\n  color: red;\n}\n\n/* popup content */\n.attx-popup-content ul {\n  list-style: none;\n  margin-top: 10px;\n  padding-left: 5px;\n}\n\n.attx-popup-content li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 10px 0;\n  font-size: 13px;\n  color: #444;\n}\n\n.attx-popup-content a {\n  color: #1d7e68;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.attx-popup-content a:hover {\n  text-decoration: underline;\n}\n\n/* animation — right se slide hote hue center tak */\n@keyframes attx-slideInCenter {\n  from {\n    transform: translate(50%, -50%);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, -50%);\n    opacity: 1;\n  }\n}\n\n/* ====================== RESPONSIVE ====================== */\n@media screen and (max-width: 1024px) {\n  .attx-main {\n    flex-direction: column;\n  }\n\n  .attx-popup {\n    width: 100%;\n    border-radius: 0 0 10px 10px;\n    margin-top: 10px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .attx-table th,\n  .attx-table td {\n    font-size: 8px;\n    padding: 3px;\n  }\n\n  .attx-popup-content li {\n    font-size: 12px;\n  }\n}\n\n.attx-verify {\n  font-size: 11px;\n  color: #1a8f6c;\n  text-decoration: none;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.attx-verify:hover {\n  text-decoration: underline;\n  color: #0e5f4a;\n}\n\n.attx-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(128, 128, 128, 0.5);\n  z-index: 999;\n}\n\n.attx-filter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin: 10px 20px;\n}\n\n.attx-filter label {\n  margin-bottom: 1px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #444;\n}\n\n.attx-filter input {\n  width: 230px;\n  padding: 7px 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 13px;\n  outline: none;\n  transition: 0.2s;\n}\n\n.attx-filter input:focus {\n  border-color: #1a8f6c;\n  box-shadow: 0 0 4px rgba(26, 143, 108, 0.3);\n}\n\n.attx-popup-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.attx-popup-list li {\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n/* Make in/out location on one line */\n.attx-inline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.attx-inline strong {\n  width: 120px; /* fixed width for label alignment */\n  flex-shrink: 0;\n}\n\n.attx-inline span {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #333;\n}\n\n.attx-scroll-text {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px;\n  vertical-align: middle;\n  position: relative;\n  cursor: pointer;\n  color: #0077cc;\n  font-size: 13px;\n}\n\n.attx-scroll-text:hover::after {\n  content: attr(title);\n  position: absolute;\n  top: 125%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #fff;\n  color: #333;\n  font-size: 11px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n  white-space: normal;\n  width: 150px;\n  z-index: 999;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.attx-scroll-text:hover {\n  color: #005fa3;\n}\n\n.attx-address-block {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  margin-left: 5px;\n}\n\n.attx-table-wrap {\n  overflow-x: auto;\n}\n\n.attx-search-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: 10px;\n}\n\n.attx-date-input {\n  width: 130px;\n  padding: 6px 8px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 13px;\n}\n\n.attx-search-button {\n  padding: 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background: white;\n  cursor: pointer;\n}\n.attx-search-input {\n  padding: 6px, 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 220px;\n  margin-left: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
